export const title = document.title.charAt(0).toUpperCase() + document.title.slice(1);

export const theoryContent = "Bites";
export const practicalContent = "Sips";